export const useIsMobile = () => {
	return 'ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/);
};
